document.body.addEventListener("update-cart", function () {
  fetch("/cart?view=quantity-breaks")
    .then((res) => res.text())
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const quantityBreaks = doc.querySelector(".quantity-breaks-wrapper");
      if (!quantityBreaks) return;
      document.querySelectorAll(".quantity-breaks-wrapper").forEach((el) => {
        el.className = quantityBreaks.className;
        el.innerHTML = quantityBreaks.innerHTML;
      });
    })
    .catch((err) => console.error(err));
});

class ProductForm extends HTMLElement {
  constructor() {
    super();
  }

  get formId() {
    return this.getAttribute("id");
  }

  get rowIndex() {
    return this.closest("[data-bundle-row-index]").dataset.bundleRowIndex;
  }

  get productIndex() {
    return this.closest("[data-product-index]").dataset.productIndex;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.form = this.querySelector("form");
    this.masterSelect =
      this.querySelector("[name='id']") ||
      this.querySelector("[data-product-select]");
    this.variants = JSON.parse(
      this.querySelector("[data-variants]")
        ? this.querySelector("[data-variants]").textContent
        : "[]"
    );
    this.product = JSON.parse(
      this.querySelector("[data-product]")
        ? this.querySelector("[data-product]").textContent
        : "{}"
    );
    this.isBundleForm = this.form.dataset.formType === "bundle-card-form";
    this.atcButton = this.querySelector("[data-atc-button]");
    this.addingText = this.querySelector("[data-adding-text]");
    this.bindEvents();
  }

  bindEvents() {
    this.addEventListener(
      "variant:change",
      this.handleVariantChange.bind(this)
    );
    this.form.addEventListener("submit", this.handleSubmit.bind(this));
    this.addEventListener("add-to-cart", this.handleSubmit.bind(this));
  }

  handleVariantChange(event) {
    const variant = event.detail.variant;
    this.masterSelect.value = variant.id;
  }

  handleSubmit(event) {
    event.preventDefault();
    if (this.isBundleForm) {
      this.addToBundle();
    } else {
      this.submit();
    }
  }

  addToBundle() {
    const variant = this.variants.find(
      (variant) => variant.id == this.masterSelect.value
    );
    const rowIndex = this.rowIndex;
    const productIndex = this.productIndex;

    const imageUrl = variant.featured_image
      ? variant.featured_image
      : this.product.featured_image;

    this.dispatchEvent(
      new CustomEvent("addToBundle", {
        detail: {
          variant: {
            id: variant.id,
            imageUrl,
            title: variant.title,
            price: variant.price,
            option1: variant.option1,
            option2: variant.option2,
            option3: variant.option3,
            options: variant.options,
          },
          product: this.product,
          rowIndex,
          productIndex,
        },
        bubbles: true,
      })
    );
  }

  submit() {
    const formData = new FormData(this.form);
    formData.append("id", this.masterSelect.value);
    formData.append("quantity", 1);
    formData.append("sections", "cart-drawer");

    if (this.addingText) {
      this.addingText.classList.remove("hidden");
    }
    fetch("/cart/add.js", {
      method: "POST",
      body: formData,
    })
      .then((res) => res.json())
      .then((data) => {
        const cartDrawerHTML = data.sections["cart-drawer"];
        const cartDrawer = document.querySelector(".cart-drawer");
        cartDrawer.reloadCart(cartDrawerHTML, true);
        this.dispatchEvent(new CustomEvent("item:added", { bubbles: true }));
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        if (this.addingText) {
          this.addingText.classList.add("hidden");
        }
      });
  }
}

if (!window.customElements.get("product-form")) {
  window.customElements.define("product-form", ProductForm);
}

class VariantPicker extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.variants = JSON.parse(
      this.querySelector("[data-variants]").textContent
    );
    this.currentVariant = null;
    this.optionInputs = this.querySelectorAll("input");
    this.linkedProductInputs = this.querySelectorAll(
      "[data-linked-product-url]"
    );
    this.bindEvents();
  }

  bindEvents() {
    this.listenToChange();
    this.linkedProductInputs.forEach((input) =>
      input.addEventListener("click", this.linkedProductClick.bind(this))
    );
  }

  linkedProductClick(e) {
    e.preventDefault();
    this.dispatchEvent(
      new CustomEvent("linked-product-change", {
        detail: { productUrl: e.target.dataset.linkedProductUrl },
        bubbles: true,
      })
    );
  }

  listenToChange() {
    this.optionInputs.forEach((input) =>
      input.addEventListener(
        "change",
        this.updateCurrentVariant.bind(this, input)
      )
    );
  }

  updateCheckedInputs() {
    this.optionInputs.forEach((input) => {
      if (input.checked) {
        input.setAttribute("checked", "checked");
      } else {
        input.removeAttribute("checked");
      }
    });
  }

  getSelectedValues() {
    return Array.from(this.querySelectorAll("input:checked")).reduce(
      (acc, input) => {
        acc[input.name] = input.value;
        return acc;
      },
      {}
    );
  }

  updateCurrentVariant(input = null) {
    const isAddOnClick = input?.dataset.addOnClick == "true";
    this.updateCheckedInputs();
    const selectedValues = this.getSelectedValues();

    this.currentVariant =
      this.variants.find((variant) => {
        return Object.entries(selectedValues).every(([name, value]) => {
          return variant[name] === value;
        });
      }) || null;

    this.querySelectorAll(".variant-picker__option").forEach((optionEl) => {
      const valueDisplay = optionEl.querySelector("[data-option-name-value]");
      const selectedInput = optionEl.querySelector("input:checked");

      if (selectedInput) {
        valueDisplay.textContent = selectedInput.value;
      }
    });

    if (this.currentVariant) {
      this.dispatchEvent(
        new CustomEvent("variant:change", {
          detail: {
            variant: this.currentVariant,
          },
          bubbles: true,
        })
      );
    }

    if (isAddOnClick) {
      this.dispatchEvent(
        new CustomEvent("add-to-cart", {
          bubbles: true,
        })
      );
    }
  }
}

if (!window.customElements.get("variant-picker")) {
  window.customElements.define("variant-picker", VariantPicker);
}

class BundleBuilder extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.numberOfRows = this.dataset.numberOfRows;
    this.chosenVariants = Array.from({
      length: parseInt(this.numberOfRows),
    }).reduce((acc, _, i) => {
      acc[i] = null;
      return acc;
    }, {});
    this.atcButtons = this.querySelectorAll("[data-bundle-add-product]");
    this.bundleVariantId = this.dataset.bundleVariantId;
    this.resetBundleButtons = this.querySelectorAll("[data-reset-bundle]");
    this.chosenProductRows = this.querySelectorAll("[data-row-chosen-product]");
    this.bindEvents();
  }

  bindEvents() {
    this.addEventListener("addToBundle", (e) => this.addToBundle(e));
    this.querySelectorAll("[data-bundle-remove-product]").forEach((button) => {
      button.addEventListener("click", (e) => {
        e.stopPropagation();
        const rowIndex = e.target.closest("[data-row-chosen-product]").dataset
          .rowChosenProduct;
        this.removeFromBundle(rowIndex);
      });
    });
    this.resetBundleButtons.forEach((el) =>
      el.addEventListener("click", this.resetBundle.bind(this))
    );
    this.atcButtons.forEach((el) =>
      el.addEventListener("click", this.addBundleToCart.bind(this))
    );
    this.chosenProductRows.forEach((el) =>
      el.addEventListener("click", () => this.handleEmptyCardClick(el))
    );
  }

  handleEmptyCardClick(el) {
    const rowIndex = el.dataset.rowChosenProduct;
    this.focusRow(rowIndex);
  }

  focusRow(rowIndex) {
    const allRows = this.querySelectorAll("[data-bundle-row-index]");
    allRows.forEach((r) => {
      const details = r.querySelector("details");
      if (details) {
        details.open = r.dataset.bundleRowIndex == rowIndex;
      }
    });
    this.closeMobileOverview();
    const row = this.querySelector(`[data-bundle-row-index="${rowIndex}"]`);

    if (row) {
      const rect = row.getBoundingClientRect();
      const isDesktop = window.matchMedia("(min-width: 48em)").matches;
      const offset = isDesktop ? 168 : 68;
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      window.scrollTo({
        top: scrollTop + rect.top - offset,
        behavior: "smooth",
      });
    }
  }

  resetBundle() {
    this.chosenVariants = Array.from({
      length: parseInt(this.numberOfRows),
    }).reduce((acc, _, i) => {
      acc[i] = null;
      return acc;
    }, {});
    this.render();
  }

  closeMobileOverview() {
    this.querySelector("bundle-overview-mobile")?.close();
  }

  addBundleToCart() {
    const chosenVariantCount = Object.values(this.chosenVariants).filter(
      Boolean
    ).length;
    if (chosenVariantCount < this.numberOfRows) {
      this.closeMobileOverview();
      return;
    }
    const bundleVariantId = Number(this.bundleVariantId);
    const uniqueBundleId =
      Date.now() + "-" + Math.random().toString(36).substring(2, 11);
    const items = Object.values(this.chosenVariants)
      .filter(Boolean)
      .map((variantAndProduct) => {
        const variant = variantAndProduct.variant;
        return {
          id: variant.id,
          quantity: 1,
          properties: {
            _bundleGroupId: uniqueBundleId,
            _bundleVariantId: bundleVariantId,
          },
        };
      });

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items,
        sections: ["cart-drawer"],
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        const cartDrawerHTML = data.sections["cart-drawer"];
        const cartDrawer = document.querySelector(".cart-drawer");
        cartDrawer.reloadCart(cartDrawerHTML, true);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  addToBundle(e) {
    const variant = e.detail.variant;
    const product = e.detail.product;
    const rowIndex = e.detail.rowIndex;
    this.chosenVariants[rowIndex] = { variant, product };
    this.render();
    this.focusRow(Number(rowIndex) + 1);
  }

  removeFromBundle(rowIndex) {
    this.chosenVariants[rowIndex] = null;
    this.render();
  }

  render() {
    this.renderCardButtons();
    this.renderChosenProducts();
    this.renderTotal();
    this.renderButton();
  }

  renderCardButtons() {
    const productCards = document.querySelectorAll(
      "product-card[data-product-id]"
    );
    const chosenProductIds = Object.values(this.chosenVariants)
      .filter((item) => item !== null)
      .map((item) => item.product.id.toString());

    productCards.forEach((card) => {
      const productId = card.dataset.productId;
      const atcButton = card.querySelector("[data-atc-button]");

      if (atcButton) {
        atcButton.classList.toggle(
          "added",
          chosenProductIds.includes(productId)
        );
      }
    });
  }

  renderChosenProducts() {
    this.querySelectorAll("[data-row-chosen-product]").forEach((el) => {
      const rowIndex = el.dataset.rowChosenProduct;
      const variantAndProduct = this.chosenVariants[rowIndex];
      const titleAndOptions = el.querySelector("[data-title-and-options]");
      const innerContent = el.querySelector("[data-inner-content]");
      if (!variantAndProduct) {
        innerContent.innerHTML = el.querySelector("[data-title]").dataset.title;
        titleAndOptions.innerHTML = "";
        return;
      }
      const variant = variantAndProduct.variant;
      const product = variantAndProduct.product;

      innerContent.innerHTML = `<img src="${variant.imageUrl}" alt="${variant.title}" />`;
      el.querySelector("[data-bundle-remove-product]").classList.toggle(
        "hidden",
        !variant
      );

      titleAndOptions.innerHTML = this.renderTitleAndOptions(product, variant);
    });
  }
  renderTitleAndOptions(product, variant) {
    const optionNames = product.options.split(",");
    return `<div class="bundle-chosen-product-title">${product.title}</div>
    ${optionNames
      .map(
        (option, index) =>
          `<p class="bundle-chosen-product-option">${option}: ${variant.options[index]}</p>`
      )
      .join("")}`;
  }

  renderTotal() {
    const total = Object.values(this.chosenVariants).reduce(
      (acc, variantAndProduct) => {
        if (!variantAndProduct) return acc;
        const variant = variantAndProduct.variant;
        const price = variant.price;
        const quantity = 1;
        return acc + price * quantity;
      },
      0
    );

    this.updateAllEls(
      "[data-bundle-final-price]",
      Shopify.formatMoney(total * 0.8, window.theme.moneyFormatNoTrailingZeros)
    );
    this.updateAllEls(
      "[data-bundle-original-price]",
      Shopify.formatMoney(total, window.theme.moneyFormatNoTrailingZeros)
    );
  }

  renderButton() {
    const disabled = Object.values(this.chosenVariants).some(
      (variant) => !variant
    );

    this.atcButtons.forEach((el) => el.classList.toggle("disabled", disabled));
  }

  updateAllEls(selector, value) {
    this.querySelectorAll(selector).forEach((el) => {
      el.innerHTML = value;
    });
  }
}

if (!window.customElements.get("bundle-builder")) {
  window.customElements.define("bundle-builder", BundleBuilder);
}

class CleanEssentialsBundle extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.numberOfProducts = 3;
    this.alreadyAddedProducts = this.dataset.alreadyAddedProducts.split(",");
    this.chosenVariants = Array.from({
      length: parseInt(this.numberOfProducts),
    }).reduce((acc, _, i) => {
      acc[i] = null;
      return acc;
    }, {});
    this.atcButtons = this.querySelectorAll("[data-bundle-add-product]");
    this.bundleVariantId = this.dataset.bundleVariantId;
    this.resetBundleButtons = this.querySelectorAll("[data-reset-bundle]");
    this.chosenProductRows = this.querySelectorAll("[data-row-chosen-product]");
    this.bindEvents();
    this.renderTotal();
  }

  bindEvents() {
    this.addEventListener("addToBundle", (e) => this.addToBundle(e));
    this.querySelectorAll("[data-bundle-remove-product]").forEach((button) => {
      button.addEventListener("click", (e) => {
        e.stopPropagation();
        const productIndex = e.target.closest("[data-chosen-product-index]")
          .dataset.chosenProductIndex;
        this.removeFromBundle(productIndex);
      });
    });
    this.resetBundleButtons.forEach((el) =>
      el.addEventListener("click", this.resetBundle.bind(this))
    );
    this.atcButtons.forEach((el) =>
      el.addEventListener("click", this.addBundleToCart.bind(this))
    );
    this.chosenProductRows.forEach((el) =>
      el.addEventListener("click", () => this.handleEmptyCardClick(el))
    );
  }

  resetBundle() {
    this.chosenVariants = Array.from({
      length: parseInt(this.numberOfRows),
    }).reduce((acc, _, i) => {
      acc[i] = null;
      return acc;
    }, {});
    this.render();
  }

  closeMobileOverview() {
    this.querySelector("bundle-overview-mobile")?.close();
  }

  addBundleToCart() {
    const bundleVariantId = Number(this.bundleVariantId);
    const uniqueBundleId =
      Date.now() + "-" + Math.random().toString(36).substring(2, 11);
    const properties = {
      _bundleGroupId: uniqueBundleId,
      _bundleVariantId: bundleVariantId,
    };
    const alreadyAddedProducts = this.alreadyAddedProducts.map((id) => ({
      id,
      quantity: 1,
      properties,
    }));
    const items = Object.values(this.chosenVariants)
      .filter(Boolean)
      .map((variantAndProduct) => {
        const variant = variantAndProduct.variant;
        return {
          id: variant.id,
          quantity: 1,
          properties,
        };
      });

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: [...alreadyAddedProducts, ...items],
        sections: ["cart-drawer"],
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        const cartDrawerHTML = data.sections["cart-drawer"];
        const cartDrawer = document.querySelector(".cart-drawer");
        cartDrawer.reloadCart(cartDrawerHTML, true);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  addToBundle(e) {
    const variant = e.detail.variant;
    const product = e.detail.product;
    const productIndex = e.detail.productIndex;
    this.chosenVariants[productIndex] = { variant, product };
    this.render();
  }

  removeFromBundle(productIndex) {
    this.chosenVariants[productIndex] = null;
    this.render();
  }

  render() {
    this.renderCardButtons();
    this.renderChosenProducts();
    this.renderTotal();
    this.renderButton();
  }

  renderCardButtons() {
    const productCards = document.querySelectorAll(
      "product-card[data-product-id]"
    );
    const chosenProductIds = Object.values(this.chosenVariants)
      .filter((item) => item !== null)
      .map((item) => item.product.id.toString());

    productCards.forEach((card) => {
      const productId = card.dataset.productId;
      const atcButton = card.querySelector("[data-atc-button]");

      if (atcButton) {
        atcButton.classList.toggle(
          "added",
          chosenProductIds.includes(productId)
        );
      }

      if (card.classList.contains("already-added")) {
        atcButton.classList.add("added");
      }
    });
  }

  renderChosenProducts() {
    this.querySelectorAll("[data-chosen-product-index]").forEach((el) => {
      const productIndex = el.dataset.chosenProductIndex;
      const variantAndProduct = this.chosenVariants[productIndex];
      const titleAndOptions = el.querySelector("[data-title-and-options]");
      const innerContent = el.querySelector("[data-inner-content]");
      if (!variantAndProduct) {
        innerContent.innerHTML = el.querySelector("[data-title]").dataset.title;
        titleAndOptions.innerHTML = "";
        return;
      }
      const variant = variantAndProduct.variant;
      const product = variantAndProduct.product;

      innerContent.innerHTML = `<img src="${variant.imageUrl}" alt="${variant.title}" />`;
      el.querySelector("[data-bundle-remove-product]").classList.toggle(
        "hidden",
        !variant
      );

      titleAndOptions.innerHTML = this.renderTitleAndOptions(product, variant);
    });
  }
  renderTitleAndOptions(product, variant) {
    const optionNames = product.options.split(",");
    return `<div class="bundle-chosen-product-title">${product.title}</div>
    ${optionNames
      .map(
        (option, index) =>
          `<p class="bundle-chosen-product-option">${option}: ${variant.options[index]}</p>`
      )
      .join("")}`;
  }

  renderTotal() {
    const total =
      Object.values(this.chosenVariants).reduce((acc, variantAndProduct) => {
        if (!variantAndProduct) return acc;
        const variant = variantAndProduct.variant;
        const price = variant.price;
        const quantity = 1;
        return acc + price * quantity;
      }, 0) + 2000;

    this.updateAllEls(
      "[data-bundle-final-price]",
      Shopify.formatMoney(total * 0.8, window.theme.moneyFormatNoTrailingZeros)
    );
    this.updateAllEls(
      "[data-bundle-original-price]",
      Shopify.formatMoney(total, window.theme.moneyFormatNoTrailingZeros)
    );
  }

  renderButton() {
    const disabled = Object.values(this.chosenVariants).some(
      (variant) => !variant
    );

    this.atcButtons.forEach((el) => el.classList.toggle("disabled", disabled));
  }

  updateAllEls(selector, value) {
    this.querySelectorAll(selector).forEach((el) => {
      el.innerHTML = value;
    });
  }
}

if (!window.customElements.get("clean-essentials-bundle")) {
  window.customElements.define(
    "clean-essentials-bundle",
    CleanEssentialsBundle
  );
}

class ProductCard extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.addEventListener("linked-product-change", (e) => {
      this.handleProductChange(e);
    });
    this.quickViewElement = this.querySelector("quick-view");
    this.templateName = this.dataset.template ?? "product-card";
    this.quickAddTriggerElement = this.querySelector(
      "[data-quick-add-trigger]"
    );
    if (this.quickViewElement) {
      this.querySelectorAll(".product-card-gallery__image-container").forEach(
        (el) => {
          el.addEventListener("click", (e) => {
            e.preventDefault();
            this.quickViewElement.classList.add("active");
          });
        }
      );
    }
    this.addEventListener("click", (e) => {
      if (e.target.closest("[data-quick-add-trigger]")) {
        e.preventDefault();
        this.querySelector("quick-add")?.classList.add("active");
      }
    });
  }

  handleProductChange(e) {
    const productUrl = e.detail.productUrl;
    this.classList.add("loading");
    fetch(productUrl + "?view=" + this.templateName)
      .then((res) => res.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const productCard = doc.querySelector("product-card");
        this.innerHTML = productCard.innerHTML;
        this.classList.remove("loading");
        this.init();
      });
  }
}

if (!window.customElements.get("product-card")) {
  customElements.define("product-card", ProductCard);
}
class ProductCardGallery extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.initSwiper();
    this.initHoverBehavior();
  }

  initHoverBehavior() {
    if (window.innerWidth < 767) return;
    this.addEventListener("mouseenter", () => {
      if (this.swiper && this.swiper.slides.length > 1) {
        this.swiper.slideTo(1);
      }
    });

    this.addEventListener("mouseleave", () => {
      if (this.swiper && this.swiper.slides.length > 0) {
        this.swiper.slideTo(0);
      }
    });
  }

  initSwiper() {
    const swiperEl = this.querySelector(".swiper");
    const prevBtn = this.querySelector(".swiper-button-prev");
    const nextBtn = this.querySelector(".swiper-button-next");

    let prevLabel, nextLabel;
    if (prevBtn) {
      prevLabel =
        prevBtn.getAttribute("aria-label") || "Go to the previous slide";
      prevBtn.setAttribute("aria-label", prevLabel);
    }

    if (nextBtn) {
      nextLabel = nextBtn.getAttribute("aria-label") || "Go to the next slide";
      nextBtn.setAttribute("aria-label", nextLabel);
    }
    this.swiper = new Swiper(this.querySelector(".swiper"), {
      slidesPerView: 1,
      spaceBetween: 10,
      pagination: {
        el: this.querySelector(".swiper-pagination"),
        clickable: true,
      },
      loop: true,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      a11y: {
        enabled: true,
        prevSlideMessage: prevLabel,
        nextSlideMessage: nextLabel,
      },
    });
  }
}
if (!window.customElements.get("product-card-gallery")) {
  customElements.define("product-card-gallery", ProductCardGallery);
}

class PageOverlay extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.addEventListener("click", () =>
      document.dispatchEvent(new CustomEvent("overlay:click"))
    );
  }
}

if (!window.customElements.get("page-overlay")) {
  customElements.define("page-overlay", PageOverlay);
}

class QuickView extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    document.addEventListener("overlay:click", () =>
      this.classList.remove("active")
    );

    this.pageOverlay = document.querySelector(".page-overlay");
    this.pageOverlay.addEventListener("click", () => this.close());

    this.querySelector("[data-close-quickview]").addEventListener("click", () =>
      this.close()
    );

    this.addEventListener("addToBundle", () => this.classList.remove("active"));

    this.addEventListener("linked-product-change", (e) => {
      e.stopPropagation();
      this.handleProductChange(e);
    });
  }

  close() {
    this.classList.remove("active");
  }

  handleProductChange(e) {
    const productUrl = e.detail.productUrl;
    this.classList.add("loading");
    fetch(productUrl + "?view=quickview")
      .then((res) => res.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const quickView = doc.querySelector("quick-view");
        quickView.classList.add("active");
        this.replaceWith(quickView);
      });
  }
}

if (!window.customElements.get("quick-view")) {
  customElements.define("quick-view", QuickView);
}

class QuickViewGallery extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this.querySelector(".swiper"), {
      slidesPerView: 1.4,
      spaceBetween: 10,
      pagination: {
        el: this.querySelector(".swiper-pagination"),
        clickable: true,
      },
      navigation: {
        nextEl: this.querySelector(".swiper-button-next"),
        prevEl: this.querySelector(".swiper-button-prev"),
      },
    });
  }
}

if (!window.customElements.get("quickview-gallery")) {
  customElements.define("quickview-gallery", QuickViewGallery);
}

class QuickAdd extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    document.addEventListener("scroll", () => this.classList.remove("active"));
    this.addEventListener("item:added", () => this.classList.remove("active"));
  }
}

if (!window.customElements.get("quick-add")) {
  customElements.define("quick-add", QuickAdd);
}

class BuyButtons extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.atcButton = this.querySelector("[data-atc-button]");
    this.isBundle = this.hasAttribute("data-bundle-card");
  }
}

if (!window.customElements.get("buy-buttons")) {
  customElements.define("buy-buttons", BuyButtons);
}

class BundleOverviewMobile extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.summaryToggle = this.querySelector("[data-summary-toggle]");
    this.summaryToggle.addEventListener("click", this.toggleSummary.bind(this));
  }

  toggleSummary() {
    this.classList.toggle("active");
  }

  close() {
    this.classList.remove("active");
  }
}

if (!window.customElements.get("bundle-overview-mobile")) {
  customElements.define("bundle-overview-mobile", BundleOverviewMobile);
}

class LoadPreviousButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.button = this.querySelector("[data-load-previous-button]");
    this.loadingText = this.querySelector("[data-loading-text]");
    this.defaultText = this.querySelector("[data-default-text]");

    this.button.addEventListener("click", () => {
      this.dispatchEvent(new CustomEvent("load-previous", { bubbles: true }));
    });
  }

  updateState(hasPreviousProducts, isLoading) {
    if (isLoading) {
      this.classList.remove("hidden");
      this.button.disabled = true;
      this.loadingText.classList.remove("hidden");
      this.defaultText.classList.add("hidden");
    } else if (!hasPreviousProducts) {
      this.classList.add("hidden");
    } else {
      this.classList.remove("hidden");
      this.button.disabled = false;
      this.loadingText.classList.add("hidden");
      this.defaultText.classList.remove("hidden");
    }
  }
}

if (!window.customElements.get("load-previous-button")) {
  customElements.define("load-previous-button", LoadPreviousButton);
}

class CollectionPage extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.apiUrl = "https://services.mybcapps.com/bc-sf-filter/filter";
    this.collectionId = document.querySelector("body").dataset.collectionId;
    this.shopUrl = Shopify.shop || window.location.hostname;
    this.filterDrawer = this.querySelector("filter-drawer");
    this.collectionGrid = this.querySelector("collection-grid");
    this.loadMoreButton = this.querySelector("load-more-button");
    this.loadPreviousButton = this.querySelector("load-previous-button");

    this.productsPerPage = 20;
    this.totalProducts = 0;
    this.isLoading = false;
    this.isLoadingPrevious = false;

    const urlParams = new URLSearchParams(window.location.search);
    this.highestPage = parseInt(urlParams.get("page")) || 1;
    this.currentPage = this.highestPage;
    this.lowestPage = this.highestPage;

    const drawerTriggers = Array.from(
      this.querySelectorAll("[data-open-filter-drawer]")
    );
    drawerTriggers.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        this.filterDrawer.open();
      });
    });

    this.listenForSortChange();
    this.syncSortUiFromUrl();

    this.addEventListener("filter-change", (e) => this.resetAndFetchResults());
    this.addEventListener("load-more", (e) => this.loadMoreProducts());
    this.addEventListener("load-previous", (e) => this.loadPreviousProducts());

    if (this.lowestPage > 1 && this.loadPreviousButton) {
      this.loadPreviousButton.updateState(true, false);
    }

    this.fetchResults();
  }

  getGridColumns() {
    return window.matchMedia("(min-width: 768px)").matches ? 4 : 2;
  }

  getEditorialCardCount() {
    const editorialCards = this.collectionGrid?.querySelector(
      "[data-editorial-cards]"
    );
    return parseInt(editorialCards?.dataset.editorialCount || "0", 10) || 0;
  }

  getEditorialSlotCount() {
    return this.getEditorialCardCount() * 2;
  }

  getProductsLimit() {
    const columns = this.getGridColumns();
    const editorialSlots = this.getEditorialSlotCount();
    const remainder = (this.productsPerPage + editorialSlots) % columns;
    return remainder === 0
      ? this.productsPerPage
      : this.productsPerPage - remainder;
  }

  getProductsLoadedCount() {
    if (this.highestPage <= 1) {
      return this.getProductsLimit();
    }

    return (
      this.getProductsLimit() + (this.highestPage - 1) * this.productsPerPage
    );
  }

  resetAndFetchResults() {
    this.highestPage = 1;
    this.lowestPage = 1;
    this.currentPage = 1;
    this.collectionGrid.clearProducts();
    this.updateURLParams();
    this.fetchResults();
  }

  fetchResults() {
    if (!this.collectionId) {
      console.log("No collection handle found.");
      return;
    }

    if (this.isLoading) return;
    this.isLoading = true;

    const requestLimit =
      this.currentPage === 1 ? this.getProductsLimit() : this.productsPerPage;

    let requestUrl = `${this.apiUrl}?shop=${this.shopUrl}&build_filter_tree=true&collection_scope=${this.collectionId}&event_type=filter&limit=${requestLimit}&page=${this.currentPage}&variant_available=true`;

    const urlParams = new URLSearchParams(window.location.search);
    const filterParams = Array.from(urlParams.entries())
      .filter(([key]) => key !== "sort" && key !== "sort_by")
      .map(([key, value]) => `${key}[]=${value}`)
      .join("&");
    requestUrl += `&${filterParams}`;

    const sortParam =
      urlParams.get("sort") || urlParams.get("sort_by");
    if (sortParam) {
      requestUrl += `&sort=${sortParam}`;
    }

    fetch(requestUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then(async (data) => {
        if (data.products && data.products.length > 0) {
          this.totalProducts = data.total_product;
          await this.collectionGrid.updateResults(
            data.products,
            data.total_product,
            this.currentPage === 1,
            this.isLoadingPrevious
          );
          if (!this.filterDrawer.initialised) {
            this.filterDrawer.initialiseTree(data.filter);
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching from Boost API:", error);
      })
      .finally(() => {
        this.isLoading = false;
        this.isLoadingPrevious = false;
        this.updateLoadMoreButton();
      });
  }

  loadMoreProducts() {
    if (this.isLoading) return;
    this.highestPage++;
    this.currentPage = this.highestPage;
    this.updateURLParams();
    this.fetchResults();
  }

  loadPreviousProducts() {
    if (this.isLoading) return;
    this.isLoadingPrevious = true;
    this.lowestPage--;
    this.currentPage = this.lowestPage;
    this.updateURLParams();
    this.fetchResults();
  }

  updateLoadMoreButton() {
    if (this.loadMoreButton) {
      const hasMoreProducts =
        this.getProductsLoadedCount() < this.totalProducts;
      this.loadMoreButton.updateState(hasMoreProducts, this.isLoading);
    }

    if (this.loadPreviousButton) {
      const hasPreviousProducts = this.lowestPage > 1;
      this.loadPreviousButton.updateState(hasPreviousProducts, this.isLoading);
    }
  }

  updateURLParams() {
    const url = new URL(window.location);
    if (this.currentPage > 1) {
      url.searchParams.set("page", this.currentPage.toString());
    } else {
      url.searchParams.delete("page");
    }
    window.history.replaceState({}, "", url);
  }

  listenForSortChange() {
    this.querySelectorAll("[data-sort-input]").forEach((el) => {
      el.addEventListener("change", this.handleSortChange.bind(this));
    });
  }

  syncSortUiFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const sortValue =
      urlParams.get("sort") || urlParams.get("sort_by");
    if (!sortValue) return;
    let matchedInput = null;
    this.querySelectorAll("[data-sort-input]").forEach((el) => {
      if (el.value === sortValue) matchedInput = el;
    });
    if (!matchedInput) return;
    this.querySelectorAll("[data-sort-input]").forEach((el) => {
      el.checked = el.value === sortValue;
    });
    const label = matchedInput.dataset.label;
    if (label) {
      this.querySelectorAll("[data-sort-value]").forEach((el) => {
        el.innerText = label;
      });
    }
  }

  handleSortChange(e) {
    this.querySelectorAll("[data-sort-input]").forEach((el) => {
      if (el.value === e.target.value) {
        el.checked = true;
      } else {
        el.checked = false;
      }
    });
    this.querySelectorAll("[data-sort-value]").forEach((el) => {
      el.innerText = e.target.dataset.label;
    });
    const url = new URL(window.location);
    url.searchParams.set("sort", e.target.value);
    url.searchParams.delete("sort_by");
    window.history.replaceState({}, "", url);
    this.resetAndFetchResults();
  }
}

if (!window.customElements.get("collection-page")) {
  customElements.define("collection-page", CollectionPage);
}

class FilterDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.overlay = document.querySelector(".filter-drawer-overlay");
    this.init();
  }

  init() {
    this.initialised = false;
    this.closeButtons = this.querySelectorAll("[data-close-filter-drawer]");
    this.closeButtons.forEach((btn) =>
      btn.addEventListener("click", () => this.close())
    );
    this.overlay.addEventListener("click", () =>
      this.classList.remove("active")
    );
  }

  initialiseTree(filterData) {
    this.populateFilterTree(filterData);
    this.addEventListener("change", this.updateTree.bind(this));
    this.setCheckedInputs();
    this.initialised = true;
  }

  setCheckedInputs() {
    const urlParams = new URLSearchParams(window.location.search);
    const filterGroups = {};

    urlParams.forEach((value, key) => {
      if (value.includes("&")) {
        filterGroups[key] = value.split("&");
      } else {
        filterGroups[key] = [value];
      }
    });

    Object.entries(filterGroups).forEach(([filterOptionId, values]) => {
      values.forEach((value) => {
        const valueInput = document.querySelector(`input[value="${value}"]`);
        if (valueInput) {
          valueInput.checked = true;
        }
      });
    });
  }

  updateTree() {
    const checkedInputs = this.querySelectorAll(
      'input[type="checkbox"]:checked'
    );
    const filterGroups = {};

    checkedInputs.forEach((input) => {
      const filterOptionId = input.dataset.filterOptionId;
      if (!filterGroups[filterOptionId]) {
        filterGroups[filterOptionId] = [];
      }
      filterGroups[filterOptionId].push(input.value);
    });

    this.setURLParams(filterGroups);
  }

  setURLParams(filterGroups) {
    const urlParams = new URLSearchParams();
    Object.entries(filterGroups).forEach(([filterOptionId, values]) => {
      urlParams.set(filterOptionId, values.join("&"));
    });
    window.history.replaceState(
      {},
      "",
      `${window.location.pathname}?${urlParams.toString()}`
    );
    this.dispatchEvent(new CustomEvent("filter-change", { bubbles: true }));
  }

  populateFilterTree(filterTree) {
    const filterTreeElement = this.querySelector("[data-filter-tree]");
    filterTree.options.forEach((option) => {
      const filterSection = this.createFilterSection(option);
      filterTreeElement.appendChild(filterSection);
    });
  }

  createFilterSection(option) {
    const filterOptions = this.createFilterOptions(option);
    const filterSection = document.createElement("div");
    filterSection.classList.add("filter-section");
    filterSection.innerHTML = `
      <div class="font-bold">${option.label}</div>
      <div class="filter-options">${filterOptions}</div>
    `;
    return filterSection;
  }

  createFilterOptions(option) {
    switch (option.displayType) {
      case "swatch":
        return this.createSwatchFilterOptions(option);
      case "list":
        return this.createListFilterOptions(option);
    }
  }

  createSwatchFilterOptions(option) {
    let filterOptions = "";
    option.values.forEach((value, idx) => {
      const id = `filter-${option.label}-${idx}`;
      filterOptions += `
        <div class="filter-list-swatch-option">
          <input type="checkbox" class="hidden"  id="${id}" value="${
        value.key
      }" data-filter-option-id="${option.filterOptionId}">
          <label class="filter-swatch swatch-${value.key
            .toLowerCase()
            .replace(/ /g, "-")}" for="${id}"><span class="sr-only">${value.key}</span></label>
        </div>
      `;
    });
    return filterOptions;
  }

  createListFilterOptions(option) {
    let filterOptions = "";
    option.values.forEach((value, idx) => {
      const id = `filter-${option.label}-${idx}`;
      filterOptions += `
        <div class="filter-list-option">
          <input title="${value.key}" type="checkbox" id="${id}" value="${value.key}" data-filter-option-id="${option.filterOptionId}">
          <label>${value.key}</label>
        </div>
      `;
    });
    return filterOptions;
  }

  open() {
    this.classList.add("active");
  }

  close() {
    this.classList.remove("active");
  }
}

if (!window.customElements.get("filter-drawer")) {
  customElements.define("filter-drawer", FilterDrawer);
}

class CollectionGrid extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {}

  /**
   * Mobile editorials are full-width (2 cols). CSS Grid leaves a hole if a
   * span-all card is ordered mid-row. Treat mobile_index as "after N products"
   * and snap N up to an even count so the card starts on a fresh row.
   * Example: index 6 → after products 1–6 (order 7); index 5 → also after 6.
   */
  normalizeMobileEditorialOrders() {
    if (!window.matchMedia("(max-width: 767px)").matches) return;

    this.querySelectorAll(".editorial-card--mobile").forEach((card) => {
      const index = parseInt(card.dataset.mobileIndex, 10);
      if (!index) return;
      const productsBefore = index % 2 === 0 ? index : index + 1;
      card.style.order = String(productsBefore + 1);
    });
  }

  async updateResults(
    products,
    productCount,
    isFirstPage = false,
    isPreviousPage = false
  ) {
    await this.addProductCards(products, isFirstPage, isPreviousPage);
    if (isFirstPage) {
      this.querySelector("[data-editorial-cards]")?.classList.remove("hidden");
      this.querySelector("[data-editorial-cards]")?.classList.add("contents");
      this.normalizeMobileEditorialOrders();
    }
    this.updateProductCount(productCount);
  }

  clearProducts() {
    const editorialCards = this.querySelector("[data-editorial-cards]");
    Array.from(this.children).forEach((child) => {
      if (child !== editorialCards) {
        child.remove();
      }
    });

    if (editorialCards) {
      editorialCards.classList.add("hidden");
      editorialCards.classList.remove("contents");
    }
  }

  async addProductCards(
    products,
    isFirstPage = false,
    isPreviousPage = false
  ) {
    const entries = await Promise.all(
      products.map(async (product, index) => {
        const productCard = await createCollectionProductCard(product);
        const order = isFirstPage ? index + 1 : isPreviousPage ? -1 : 999;
        productCard.style.order = order;
        return { index, productCard };
      })
    );
    entries
      .sort((a, b) => a.index - b.index)
      .forEach(({ productCard }) => this.appendChild(productCard));
  }

  updateProductCount(count) {
    document.querySelectorAll("[data-number-of-products]").forEach((el) => {
      if (el.dataset.includeBrackets && el.dataset.includeBrackets == "true") {
        el.innerText = `(${count})`;
      } else {
        el.innerText = count;
      }
    });
  }
}

if (!window.customElements.get("collection-grid")) {
  customElements.define("collection-grid", CollectionGrid);
}

class SortSelector extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.popoverOverlay = this.querySelector("[data-sort-popover-overlay]");
    this.popoverTrigger = this.querySelector("[data-sort-popover-trigger]");
    this.popoverTrigger.addEventListener(
      "click",
      this.togglePopover.bind(this)
    );
    this.addEventListener("change", this.handleChange.bind(this));

    document.addEventListener("click", this.handleClickAway.bind(this));
  }

  handleChange(e) {
    this.dispatchEvent(new CustomEvent("sort-change", { bubbles: true }));
    this.closePopover();
  }

  closePopover() {
    this.popoverOverlay.classList.remove("active");
  }

  togglePopover() {
    this.popoverOverlay.classList.toggle("active");
  }

  handleClickAway(event) {
    if (!this.contains(event.target)) {
      this.popoverOverlay.classList.remove("active");
    }
  }

  disconnectedCallback() {
    document.removeEventListener("click", this.handleClickAway.bind(this));
  }
}
if (!window.customElements.get("sort-selector")) {
  customElements.define("sort-selector", SortSelector);
}

class LoadMoreButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.button = this.querySelector("[data-load-more-button]");
    this.loadingText = this.querySelector("[data-loading-text]");
    this.defaultText = this.querySelector("[data-default-text]");
    this.noMoreText = this.querySelector("[data-no-more-text]");

    this.button.addEventListener("click", () => {
      this.dispatchEvent(new CustomEvent("load-more", { bubbles: true }));
    });
  }

  updateState(hasMoreProducts, isLoading) {
    if (isLoading) {
      this.classList.remove("hidden");
      this.button.disabled = true;
      this.loadingText.classList.remove("hidden");
      this.defaultText.classList.add("hidden");
    } else if (!hasMoreProducts) {
      this.classList.add("hidden");
    } else {
      this.classList.remove("hidden");
      this.button.disabled = false;
      this.loadingText.classList.add("hidden");
      this.defaultText.classList.remove("hidden");
    }
  }
}

if (!window.customElements.get("load-more-button")) {
  customElements.define("load-more-button", LoadMoreButton);
}

class SwitchImageGridCarousel extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.numberOfSlides = this.dataset.numberOfSlides;
    this.swiper = new Swiper(this, {
      slidesPerView: 1.2,
      spaceBetween: 10,
      breakpoints: {
        768: {
          slidesPerView: this.numberOfSlides,
        },
      },
    });
  }
}
if (!window.customElements.get("switch-image-grid-carousel")) {
  customElements.define("switch-image-grid-carousel", SwitchImageGridCarousel);
}

class ClickVideo extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.classList.add("paused");
    this.video = this.querySelector("video");
    this.playButton = document.createElement("div");
    this.playButton.className = "click-video-play-button";
    this.playButton.innerHTML = `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 5.14V19.14L19 12.14L8 5.14Z" fill="white"/>
      </svg>
    `;
    this.appendChild(this.playButton);
    this.bindEvents();
  }

  bindEvents() {
    this.addEventListener("click", this.toggleVideo.bind(this));
  }

  toggleVideo() {
    if (this.video.paused) {
      document.querySelectorAll("video").forEach((video) => video.pause());
      document
        .querySelectorAll("click-video")
        .forEach((video) => video.classList.add("paused"));
      this.video.play();
    } else {
      this.video.pause();
    }
    this.classList.toggle("paused", this.video.paused);
  }
}

if (!window.customElements.get("click-video")) {
  window.customElements.define("click-video", ClickVideo);
}

class SwitchVideos extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.swiper = new Swiper(this, {
      slidesPerView: 1.4,
      spaceBetween: 20,
      slidesOffsetBefore: 20,
      slidesOffsetAfter: 20,
      mousewheel: {
        forceToAxis: true,
        releaseOnEdges: true,
        sensitivity: 1,
      },
      pagination: {
        el: this.querySelector(".swiper-pagination"),
        type: "progressbar",
      },
      breakpoints: {
        768: {
          slidesPerView: 4.2,
          spaceBetween: 32,
          slidesOffsetBefore: 120,
          slidesOffsetAfter: 120,
        },
      },
    });
  }
}

if (!window.customElements.get("switch-videos")) {
  customElements.define("switch-videos", SwitchVideos);
}

class AmbassadorImages extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.swiper = new Swiper(this, {
      slidesPerView: 1.4,
      spaceBetween: 20,
      slidesOffsetBefore: 20,
      slidesOffsetAfter: 20,
      mousewheel: {
        forceToAxis: true,
        releaseOnEdges: true,
        sensitivity: 1,
      },
      pagination: {
        el: this.querySelector(".swiper-pagination"),
        type: "progressbar",
      },
      breakpoints: {
        768: {
          slidesPerView: 4.2,
          spaceBetween: 32,
          slidesOffsetBefore: 120,
          slidesOffsetAfter: 120,
        },
      },
    });
  }
}

if (!window.customElements.get("ambassador-images")) {
  customElements.define("ambassador-images", AmbassadorImages);
}

class QuickCollections extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.initSwiper();
    this.updateSelectedCollection();
    this.bindEvents();
  }

  initSwiper() {
    this.swiper = new Swiper(this.querySelector(".swiper"), {
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 8,
      loop: false,
      navigation: {
        nextEl: this.querySelector(".swiper-button-next"),
        prevEl: this.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        768: {
          slidesPerView: 6,
          slidesPerGroup: 6,
          spaceBetween: 20,
        },
      },
    });
  }

  updateSelectedCollection() {
    this.querySelectorAll(".quick-collection").forEach((collection) => {
      const filterValue = collection.dataset.filter
        .replaceAll(" ", "+")
        .toLowerCase();
      const selected = window.location.href.toLowerCase().includes(filterValue);
      collection.classList.toggle("selected", selected);
    });
  }

  bindEvents() {
    this.addEventListener("click", (e) => {
      const quickCollection = e.target.closest(".quick-collection");
      if (quickCollection) {
        this.handleCollectionClick(quickCollection);
      }
    });
  }

  handleCollectionClick(collection) {
    const filterValue = collection.dataset.filter;
    const url = new URL(window.location.href);

    if (filterValue) {
      url.searchParams.set("pf_t_style", filterValue);
    }

    if (url.href !== window.location.href) {
      window.location = url.href;
    }
  }
}

if (!window.customElements.get("quick-collections")) {
  customElements.define("quick-collections", QuickCollections);
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.cartCount = document.querySelector("[data-cart-count]");
    this.cartButton = document.querySelector("[data-cart-trigger]");
    this.cartButton.addEventListener("click", () => this.openCartDrawer());
    this.closeButton = document.querySelector("[data-close-cart-drawer]");
    this.closeButton.addEventListener("click", () => this.closeCartDrawer());
    this.pageOverlay = document.querySelector(".page-overlay");
    this.pageOverlay.addEventListener("click", () => this.closeCartDrawer());
    this.addEventListener("quantity-change", this.onQuantityChange);
    this.giftWrapToggle = this.querySelector("[data-gift-note-toggle]");
    if (this.giftWrapToggle) {
      this.giftWrapToggle.addEventListener(
        "click",
        this.addGiftNote.bind(this)
      );
    }

    this.querySelectorAll("[data-remove-from-cart]").forEach((button) =>
      button.addEventListener("click", this.onRemoveFromCart.bind(this))
    );

    this.toggleLoading = this.toggleLoading.bind(this);
    this.addEventListener("cart-loading", this.toggleLoading);
    this.toggleLoading(false);
  }

  toggleLoading(show) {
    this.classList.toggle("loading", show);
  }

  openCartDrawer() {
    this.classList.add("open");
  }

  closeCartDrawer() {
    this.classList.remove("open");
  }

  addGiftNote() {
    this.toggleLoading(true);
    fetch(`/cart/add.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: this.giftWrapToggle.value,
        quantity: 1,
        sections: ["cart-drawer"],
      }),
    })
      .then((res) => res.json())
      .then((data) => this.reloadCart(data.sections["cart-drawer"]));
  }

  reloadCart(html = null, open = false) {
    if (html) {
      this.updateContent(html);
    } else {
      fetch("?section_id=cart-drawer")
        .then((response) => response.text())
        .then((res) => this.updateContent(res));
    }

    if (open) {
      this.openCartDrawer();
    }
  }

  updateContent(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    this.innerHTML = doc.querySelector("cart-drawer").innerHTML;
    this.init();
    this.updateCartCount();
    document.body.dispatchEvent(new CustomEvent("update-cart"));
  }

  updateCartCount() {
    const updatedCartCount = this.querySelector("[data-updated-cart-count]");
    if (updatedCartCount && this.cartCount) {
      this.cartCount.textContent = updatedCartCount.textContent;
    }
  }

  onQuantityChange(event) {
    const { lineItemId, quantity } = event.detail;

    const updates = {
      [lineItemId]: quantity,
    };

    this.dispatchEvent(
      new CustomEvent("cart-loading", { detail: { show: true }, bubbles: true })
    );

    fetch(`/cart/update.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates }),
    }).then(() => this.reloadCart());
  }

  async onRemoveFromCart(event) {
    const lineItemKey = event.target.dataset.removeFromCart;

    this.dispatchEvent(
      new CustomEvent("cart-loading", { detail: { show: true }, bubbles: true })
    );

    if (event.target.dataset.removeGiftWrap != null) {
      await this.removeCartNote();
    }

    fetch(`/cart/change.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id: lineItemKey, quantity: 0 }),
    }).then(() => this.reloadCart());
  }

  async removeCartNote() {
    await fetch(`/cart/update.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        note: "",
      }),
    });
    console.log("cart note removed");
  }
}
if (!window.customElements.get("cart-drawer")) {
  customElements.define("cart-drawer", CartDrawer);
}

class CartProgress extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.currency = this.dataset.currency;
    this.totalPrice = Number(this.dataset.totalPrice);
    this.shippingThresholdInUSD = this.dataset.shippingThreshold;
    this.currencySymbol = this.dataset.currencySymbol;
    if (this.currency === "USD") return;

    const shippingThreshold = Number(
      Currency.convert(
        this.shippingThresholdInUSD,
        this.currency,
        "USD"
      ).toFixed(2)
    );

    if (this.querySelector("[data-amount-to-free-shipping]")) {
      this.querySelector("[data-amount-to-free-shipping]").textContent =
        Shopify.formatMoney(
          shippingThreshold - this.totalPrice,
          this.currencySymbol + "{{amount}}"
        );
    }
  }
}

if (!window.customElements.get("cart-progress")) {
  window.customElements.define("cart-progress", CartProgress);
}

class QuantitySelector extends HTMLElement {
  constructor() {
    super();
  }

  init() {
    this.quantityInput = this.querySelector("[data-quantity-input]");
    this.decreaseButton = this.querySelector("[data-decrease-quantity]");
    this.increaseButton = this.querySelector("[data-increase-quantity]");
    this.quantity = parseInt(this.dataset.quantity);
    this.decreaseButton.addEventListener(
      "click",
      this.onDecreaseQuantity.bind(this)
    );
    this.increaseButton.addEventListener(
      "click",
      this.onIncreaseQuantity.bind(this)
    );
  }

  connectedCallback() {
    this.init();
  }

  onDecreaseQuantity() {
    if (this.quantity > 0) {
      this.quantity--;
      this.onQuantityChange();
    }
  }

  onIncreaseQuantity() {
    this.quantity++;
    this.onQuantityChange();
  }

  onQuantityChange() {
    this.quantityInput.textContent = this.quantity;
    this.dispatchEvent(
      new CustomEvent("quantity-change", {
        detail: {
          lineItemId: this.dataset.lineItemId,
          quantity: this.quantity,
        },
        bubbles: true,
      })
    );
  }
}

if (!window.customElements.get("quantity-selector")) {
  window.customElements.define("quantity-selector", QuantitySelector);
}

class StickyATC extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.pageAtcButton = document.querySelector("[data-add-to-cart]");
    this.scrollToAtc = this.querySelector("[data-scroll-to-atc]");
    this.scrollToAtc.addEventListener("click", () => {
      if (this.pageAtcButton) {
        this.pageAtcButton.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    });
    this.init();
  }

  init() {
    if (!this.pageAtcButton) {
      console.warn("Main ATC button not found");
      return;
    }

    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          const buttonRect = this.pageAtcButton.getBoundingClientRect();
          const isButtonVisible =
            buttonRect.top >= 0 && buttonRect.bottom <= window.innerHeight;

          if (isButtonVisible) {
            this.hide();
          } else {
            this.show();
          }

          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    handleScroll();
  }

  show() {
    this.classList.add("show");
  }

  hide() {
    this.classList.remove("show");
  }
}

if (!window.customElements.get("sticky-atc")) {
  customElements.define("sticky-atc", StickyATC);
}


class HolidayCarouselSwiper extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    const prevBtn = document.querySelector(`[data-prev="${this.dataset.sectionId}"]`);
    const nextBtn = document.querySelector(`[data-next="${this.dataset.sectionId}"]`);
    this.swiper = new Swiper(this, {
      slidesPerView: 1.2,
      spaceBetween: 18,
      slidesOffsetBefore: 20,
      slidesOffsetAfter: 20,
      freeMode: true,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
    });
  }
}

if (!window.customElements.get("holiday-carousel-swiper")) {
  customElements.define("holiday-carousel-swiper", HolidayCarouselSwiper);
}